import styled from 'styled-components';
export var CardInfo = styled.div.withConfig({
  displayName: "CardInfo",
  componentId: "sc-nnskpb-0"
})(["display:flex;position:relative;padding:", ";border:1px solid rgb(229 229 229 / 0.8);border-radius:", ";box-shadow:0 4px 24px rgb(46 46 51 / 0.02),0 4px 8px rgb(229 229 229 / 0.8);background-color:#fff;color:", ";:hover{box-shadow:", ";}"], function (_ref) {
  var padding = _ref.padding;
  return padding ? padding : '15px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.font;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.extraBlack;
});